export default "__VITE_ASSET__dqQ80gyu__"